import * as React from "react";
import { ListLine } from "../framework/listLine";
import { IDocumentCompanyListItem } from "../../models/document/documentCompanyListItem";

//DocumentListCompanyLine
export interface IDocumentListCompanyLineProp {
    classes?: string;
    item: IDocumentCompanyListItem;
    onClick: (id: string, companyId: string) => void;
}

export class DocumentListCompanyLine extends React.Component<IDocumentListCompanyLineProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        return (
            <ListLine
                id={item.id}
                first={false}
                selected={false}
                classes={"line company" + (props.classes ? " " + props.classes : "")}
                onClick={(companyId) => { props.onClick(item.rootDirectoryItemId, companyId); }}
                onLongPress={null}
                onRefreshList={null}>
                <div className="row">
                    <div className="col col-12">
                        <div className="iconCont">
                            <img alt="..." src={item.logo} />
                        </div>
                        <div className="dataCont">
                            <div className={"singleLine"}>{item.name}</div>
                        </div>
                    </div>
                </div>
            </ListLine>
        );
    }
}